import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLoopComponent } from './simple-icons-loop.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLoopComponent ],
    exports:      [ SimpleIconsLoopComponent ],
    bootstrap:    []
})
export class SimpleIconsLoopModule {}
